module.exports = __webpack_public_path__ + "static/media/evening.d005b896.jpg";